import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {LoginGuard} from 'guards/login.guard';
import {CModulesDetailsComponent} from './cmodules-details.component';

const routes: Routes = [
  {path: 'cmodules/details', component: CModulesDetailsComponent, canActivate: [LoginGuard]},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class CModulesDetailsRoutingModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/cmodules/cmodules-details/cmodules-details-routing.module.ts